export default {
  comonProperties: [{ label: 'Title', name: 'title', isComonProperty: true, type: 'text' }],
  properties: []
};